<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <!-- Profile Image -->
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">
              Photo de profil
            </label>
            <div class="d-flex align-items-center">
              <img
                v-if="imagepreview"
                :src="imagepreview"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <div>
                <input
                  ref="updateImgInput"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="logoSelected"
                />
                <button
                  type="button"
                  class="btn btn-primary me-2"
                  @click="() => updateImgInput?.click()"
                >
                  Choisir la photo
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="cancelImage"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>

          <!-- Nom complet -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Nom complet *</label
            >
            <input
              v-model="form.name"
              type="text"
              class="form-control shadow-none rounded-0"
              placeholder="Nom complet"
              required
            />
          </div>

          <!-- Téléphone -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Numéro de téléphone *</label
            >
            <input
              v-model="form.phone"
              type="text"
              pattern="^0[0-9]{9}$"
              class="form-control shadow-none rounded-0"
              placeholder="0XXXXXXXXX"
              required
            />
          </div>

          <!-- Email -->
          <div class="col-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Adresse électronique *</label
            >
            <input
              v-model="form.email"
              type="email"
              class="form-control shadow-none rounded-0"
              placeholder="exemple@email.com"
              required
            />
          </div>

          <!-- Password -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Mot de passe *</label
            >
            <input
              v-model="form.password"
              type="password"
              class="form-control shadow-none rounded-0"
              placeholder="Mot de passe"
              required
            />
          </div>

          <!-- Confirm Password -->
          <div class="col-md-6 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >Confirmation de mot de passe *</label
            >
            <input
              v-model="form.c_password"
              type="password"
              class="form-control shadow-none rounded-0"
              placeholder="Confirmer mot de passe"
              required
            />
          </div>

          <!-- Submit -->
          <div
            class="col-md-12 d-flex align-items-center justify-content-between mt-20"
          >
            <button type="submit" class="btn btn-success px-4 py-2">
              Enregistrer
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm ms-2"
              ></span>
            </button>
            <button type="button" class="btn btn-link text-danger">
              Annuler
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import api from "@/utils/axios";
import { useToast, POSITION } from "vue-toastification";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
// import ImageUpload from "./ImageUpload.vue";

export default defineComponent({
  name: "AddUser",
  components: {
    // ImageUpload,
  },
  setup: () => {
    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const attachments = ref<File[]>([]);
    const urls = ref<string[]>([]);
    const loading = ref(false);

    const form = reactive({
      name: "",
      phone: "",
      email: "",
      password: "",
      c_password: "",
      image: null as File | null,
    });

    // Example static lists

    const { showToast } = useAppToast();

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        form.image = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const fileSelected = (e: Event) => {
      const files = Array.from((e.target as HTMLInputElement).files || []);
      attachments.value = files;
      urls.value = files.map((f) => URL.createObjectURL(f));
    };

    const removeFiles = () => {
      attachments.value = [];
      urls.value = [];
    };

    const getFees = (zone: any) => {
      // fetch fees for selected zone
      console.log("Fetch fees for", zone);
    };

    const handleSubmit = async () => {
      if (form.password !== form.c_password) {
        console.error("Passwords do not match");
        showToast("Merci de verifier les mots de passe", "error");
        return;
      }

      if (
        !form.name ||
        !form.email ||
        !form.password
        // || !form.city
      ) {
        showToast("Merci de remplir tous les champ", "error");
        return;
      }

      const data = new FormData();

      data.append("email", form.email);
      data.append("password", form.password);
      data.append("phone", form.phone);
      data.append("name", form.name);
      data.append("image", form.image);

      if (form.image) data.append("pic", form.image);

      try {
        console.log("Submitting form with data:", data);
        loading.value = true;
        const res = await api.post(`/api/auth/client/NewCustomerUser`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log(res);

        if (res.data.msg === "success" || res.data.success) {
          showToast("Utilisateur est bien ajouté", "success");
          router.push("/users-list");
        } else if (res.data.msg === "not match") {
          showToast("Merci de verifier les mots de passe", "error");
        } else if (res.data.msg === "email exist") {
          showToast("Merci de verifier l'email, est déjà utilisé", "error");
        } else if (res.data.msg === "no customer") {
          showToast("Vous ne pouvez pas ajouter un utilisateur", "error");
        } else {
          showToast("Erreur lors de l'ajout de l'utilisateur", "error");
        }
      } catch (err) {
        console.error("Error submitting form:", err);
      } finally {
        loading.value = false;
      }
    };

    return {
      updateImgInput,
      imagepreview,
      attachments,
      urls,
      form,
      loading,
      logoSelected,
      cancelImage,
      fileSelected,
      removeFiles,
      getFees,
      handleSubmit,
    };
  },
});
</script>